import { cva } from "class-variance-authority";
import ItemsTooltip, {
  type ItemsTooltipVariant,
} from "~/molecules/ItemsTooltip";

const moreTooltipVariants = cva(
  "flex shrink-0 items-center justify-center text-xs font-medium transition-colors",
  {
    variants: {
      variant: {
        category:
          "size-5 rounded-full bg-primary/10 hover:bg-primary/30 text-primary",
        tag: "rounded-full bg-tag-muted/50 px-1.5 py-0.5 text-tag font-semibold whitespace-nowrap hover:bg-tag-muted",
      },
    },
  },
);

interface Props {
  data: string[];
  variant?: ItemsTooltipVariant;
  visibleCount?: number;
}

const MoreTooltip = ({
  data,
  variant = "category",
  visibleCount = 1,
}: Props) => {
  if (data.length <= visibleCount) return null;

  return (
    <ItemsTooltip items={data.slice(visibleCount)} variant={variant}>
      <span className={moreTooltipVariants({ variant })}>
        +{data.length - visibleCount}
      </span>
    </ItemsTooltip>
  );
};

export default MoreTooltip;
